import React, { ReactNode } from "react";

import * as Styles from "./FormLabel.styles";

type Props = {
  children?: ReactNode;
};

export const FormLabel = (props: Props) => {
  return (
    <Styles.Label className="flex flex-col gap-1">
      {props.children}
    </Styles.Label>
  );
};
